// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import position from './metaData/position'
export default {
  state: position,
  actions
}
